const rankingItems = [
  { rank: 1, title: '咒术回战', tag: '本周最热', desc: '涉谷事变篇高潮迭起，宿傩VS五条悟的世纪之战引爆全场。', change: 'up' },
  { rank: 2, title: '海贼王', tag: '经典连载', desc: '最终章剧情白热化，路飞尼卡形态与黑胡子终极对决。', change: 'same' },
  { rank: 3, title: '间谍过家家', tag: '治愈首选', desc: '番外篇更新中，安妮亚的校园生活萌翻全网读者。', change: 'up' },
  { rank: 4, title: '坂本日常', tag: '急速上升', desc: '新篇章开启，昔日杀手搭档现身，剧情进入新高潮。', change: 'up' },
  { rank: 5, title: '葬送的芙莉莲', tag: '口碑封神', desc: '时空穿越篇感动百万读者，被誉为近年最佳奇幻漫画。', change: 'down' },
  { rank: 6, title: '怪兽8号', tag: '黑马之姿', desc: '动画化效应显著，原作漫画阅读量暴涨300%。', change: 'up' },
];

export default function Ranking() {
  return (
    <section id="ranking" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
        <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-900 mb-2 text-center">
          热门排行榜
        </h2>
        <p className="text-foreground-500 text-sm text-center mb-10">大家都在看的热门漫画</p>

        <div className="space-y-3">
          {rankingItems.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 bg-background-100 rounded-xl p-4 cursor-pointer transition-all duration-200 hover:ring-2 hover:ring-primary-200"
            >
              <div className={`w-9 h-9 rounded-lg flex items-center justify-center font-heading font-bold text-sm flex-shrink-0 ${
                item.rank === 1 ? 'bg-primary-500 text-background-50' :
                item.rank === 2 ? 'bg-secondary-500 text-background-50' :
                item.rank === 3 ? 'bg-accent-500 text-background-50' :
                'bg-background-200 text-foreground-500'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap mb-0.5">
                  <h3 className="font-heading font-bold text-sm text-foreground-900">{item.title}</h3>
                  <span className="px-2 py-0.5 rounded bg-secondary-100 text-secondary-700 text-[10px] font-semibold whitespace-nowrap">{item.tag}</span>
                </div>
                <p className="text-foreground-500 text-xs leading-relaxed truncate">{item.desc}</p>
              </div>
              <div className="flex-shrink-0">
                {item.change === 'up' && <i className="ri-arrow-up-line text-accent-500 text-lg"></i>}
                {item.change === 'down' && <i className="ri-arrow-down-line text-primary-500 text-lg"></i>}
                {item.change === 'same' && <i className="ri-subtract-line text-foreground-400 text-lg"></i>}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}